<span class="color--gray--004 txt-14">
  <span>
    Added by
  </span>
  <button type="button"
          aria-label="Opens dialog to select or change users and time frame"
          class="link link--small p-0"
          (click)="buttonClicked()">{{getUserText()}}, {{getTimeText() | lowercase}}
  </button>
</span>
